import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKadoOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 223.82 223.82",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			gradientUnits: "userSpaceOnUse",
			x1: 34.91,
			x2: 133.23,
			y1: 164.69,
			y2: 164.69,
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#fcc997"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#d55566"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#b5697d"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "b",
			gradientUnits: "userSpaceOnUse",
			x1: 34.91,
			x2: 188.91,
			y1: 111.91,
			y2: 111.91,
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#fcc997"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#d55566"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#8b849b"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "c",
			gradientUnits: "userSpaceOnUse",
			x1: 34.91,
			x2: 81.3,
			y1: 41.54,
			y2: 41.54,
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#fcc997"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#e17975"
			})]
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "d",
			x1: 34.91,
			x2: 81.3,
			xlinkHref: "#c",
			y1: 182.28,
			y2: 182.28
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "e",
			x1: 34.91,
			x2: 133.23,
			xlinkHref: "#a",
			y1: 59.13,
			y2: 59.13
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "f",
			gradientUnits: "userSpaceOnUse",
			x2: 223.82,
			y1: 111.91,
			y2: 111.91,
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#fcc997"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#d55566"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6b98b2"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m121.8 186.85a6.63 6.63 0 1 0 9.61-9.14l-17.8-18.71a59.94 59.94 0 0 0 -43.23-18.53h-28.84a6.63 6.63 0 0 0 0 13.26h28.84a46.61 46.61 0 0 1 33.62 14.41z",
			fill: "url(#a)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m187 46.23a6.63 6.63 0 0 0 -9.37-9.38l-54.87 54.84a46.09 46.09 0 0 1 -32.82 13.59h-48.4a6.63 6.63 0 1 0 0 13.26h48.4a46.14 46.14 0 0 1 32.82 13.59l54.84 54.87a6.63 6.63 0 0 0 9.37-9.38l-54.84-54.83a60 60 0 0 0 -14.82-10.85 59.68 59.68 0 0 0 14.82-10.84z",
			fill: "url(#b)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m41.54 48.17h33.13a6.63 6.63 0 0 0 0-13.26h-33.13a6.63 6.63 0 0 0 0 13.26z",
			fill: "url(#c)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m41.54 175.65a6.63 6.63 0 0 0 0 13.26h33.13a6.63 6.63 0 0 0 0-13.26z",
			fill: "url(#d)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m41.54 83.36h28.84a60 60 0 0 0 43.23-18.54l17.8-18.71a6.63 6.63 0 0 0 -9.61-9.11l-17.8 18.68a46.62 46.62 0 0 1 -33.62 14.42h-28.84a6.63 6.63 0 0 0 0 13.26z",
			fill: "url(#e)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m186.08 12a25.78 25.78 0 0 1 25.74 25.75v148.33a25.77 25.77 0 0 1 -25.74 25.74h-148.33a25.78 25.78 0 0 1 -25.75-25.74v-148.33a25.78 25.78 0 0 1 25.75-25.75zm0-12h-148.33a37.86 37.86 0 0 0 -37.75 37.75v148.33a37.86 37.86 0 0 0 37.75 37.74h148.33a37.85 37.85 0 0 0 37.74-37.74v-148.33a37.86 37.86 0 0 0 -37.74-37.75z",
			fill: "url(#f)"
		})
	]
});
export default SvgKadoOutline;
